import React from 'react'
import { TextField, MenuItem } from '@material-ui/core'

type Option = { label: string; value: string }

type Props = {
  label: string
  name: string
  kind?: 'text' | 'email' | 'tel' | 'number' | 'textarea' | 'select'
  required?: boolean
  placeholder?: string
  value?: string | number
  error?: string
  helperText?: string
  rows?: number
  options?: Option[]
  onChange: (value: string) => void
}

const BasicInput: React.FC<Props> = ({
  label,
  name,
  kind = 'text',
  required,
  placeholder,
  value,
  error,
  helperText,
  rows = 4,
  options = [],
  onChange,
}) => {
  const isSelect = kind === 'select'
  const isTextarea = kind === 'textarea'
  const inputType = isSelect || isTextarea ? undefined : kind

  return (
    <TextField
      fullWidth
      select={isSelect}
      multiline={isTextarea}
      rows={isTextarea ? rows : undefined}
      type={inputType}
      label={label}
      name={name}
      placeholder={placeholder}
      required={required}
      value={(value as any) ?? ''}
      onChange={(e) => onChange((e.target as HTMLInputElement).value)}
      error={Boolean(error)}
      helperText={error || helperText}
      margin="normal"
      inputProps={
        kind === 'number'
          ? { inputMode: 'numeric', pattern: '[0-9]*' }
          : undefined
      }
    >
      {isSelect &&
        options.map((opt, idx) => (
          <MenuItem key={idx} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
    </TextField>
  )
}

export default BasicInput
